<template>
  <div class="accordion-item">
    <div class="accordion-header">
      <h2 class="custom-h accordion-title">
        <button
          class="custom-btn flex"
          type="button"
          data-toggle="collapse"
          :data-target="'#' + collapseId"
          :aria-controls="collapseId"
          :aria-expanded="showCollapse || hasError ? 'true' : 'false'"
          @click="!disableToggle && toggle()"
        >
          <span :class="{ required: required }">
            <slot name="title">{{ title }}</slot>
          </span>
        </button>
      </h2>
    </div>
    <div
      :id="collapseId"
      :class="['collapse', { show: showCollapse || hasError }]"
      :data-parent="accordionParent ? '#' + accordionParent : null"
      ref="collapseElement"
    >
      <div class="accordion-body">
        <form action="">
          <transition name="fade">
            <div v-show="true">
              <slot />
            </div>
          </transition>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCollapse",
  props: {
    title: { type: String, default: "" },
    required: { type: Boolean, default: true },
    open: { type: Boolean, default: undefined },
    defaultOpen: { type: Boolean, default: true },
    collapseId: { type: String, required: true },
    disableToggle: { type: Boolean, default: false },
    accordionParent: { type: String, default: null },
    hasError: { type: Boolean, default: false },
  },
  data() {
    return {
      internalOpen: this.defaultOpen,
    };
  },
  computed: {
    isControlled() {
      return this.open !== undefined;
    },
    showCollapse() {
      return this.isControlled ? this.open : this.internalOpen;
    },
  },
  methods: {
    toggle() {
      if (this.isControlled) {
        this.$emit("update:open", !this.open);
      } else {
        this.internalOpen = !this.internalOpen;
      }
    },
    syncWithBootstrap() {
      
      // Force Bootstrap collapse to sync with Vue state
      this.$nextTick(() => {
        const $collapse = $(this.$refs.collapseElement);
        const shouldShow = this.showCollapse || this.hasError;
        
        if (shouldShow && !$collapse.hasClass('show')) {
          $collapse.collapse('show');
        } else if (!shouldShow && $collapse.hasClass('show')) {
          $collapse.collapse('hide');
        }
      });
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(val) {
        if (this.isControlled) {
          this.internalOpen = val;
        }
        this.syncWithBootstrap();
      },
    },
    hasError: {
      immediate: true,
      handler() {
        this.syncWithBootstrap();
      },
    },
    showCollapse: {
      immediate: true,
      handler() {
        this.syncWithBootstrap();
      },
    },
  },
  mounted() {
    // Initialize Bootstrap collapse
    $(this.$refs.collapseElement).collapse({
      toggle: false // Don't auto-toggle on init
    });
    
    // Sync initial state
    this.syncWithBootstrap();
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>